<i18n>
{
	"en": {
		"deviations": "Deviations",
		"mustSaveTrip": "The trip must be saved before a deviation can be connected to it.",
		"noDeviations": "There are no registered deviations.",
		"addDeviation": "Add new deviation"
	},

	"no": {
		"deviations": "Avvik",
		"mustSaveTrip": "Turen må lagres før avvik kan tilknyttes.",
		"noDeviations": "Det er ingen registrerte avvik.",
		"addDeviation": "Legg til nytt avvik"
	}
}
</i18n>

<template>
	<div class="main">
		<h3>
			Avvik knyttet til turen
		</h3>

		<DeviationGrid
			v-if="deviations && deviations.length > 0"
			:deviations="deviations"
			:style="`height: ${gridHeight}px`"
			@rowDoubleClick="editDeviation"
		/>

		<t-no-content-panel
			v-else
			:text="$t('noDeviations')"
			icon="warning-sign"
			iconType="bp"
			class="no-content"
			noBetweenGap
		/>

		<t-button
			class="add-button"
			iconBefore="add"
			:disabled="!tripIsSaved"
			:title="!tripIsSaved ? $t('mustSaveTrip') : ''"
			@click="addDeviation"
		>
			{{$t('addDeviation')}}
		</t-button>
	</div>
</template>

<script>
import { mapActions as mapTripActions } from './store/newTrip.store.js';
import { mapActions as mapDeviationActions } from '@/modules/newDeviation/store/newDeviation.store.js';
import DeviationGrid from '@/modules/deviations/DeviationGrid';

export default {
	name: 'Deviations',
	components: {
		DeviationGrid,
	},

	props: {
		trip: Object,
	},

	computed: {
		tripIsSaved() {
			return Boolean(this.trip && this.trip.id);
		},
		deviations() {
			return this.trip.deviations || [];
		},
		gridHeight() {
			return (44 + this.trip.deviations.length * 40);
		},
	},

	methods: {
		...mapTripActions(['setDeviations']),
		...mapDeviationActions([
			'returnDeviation',
			'newDeviation',
			'loadDeviation',
		]),
		async editDeviation(deviationId) {
			let updatedDeviation = await (await this.returnDeviation(this.loadDeviation))(deviationId);
			if (!updatedDeviation) return;
			let newDeviations = this.deviations.map(d => d.id === updatedDeviation.id ? updatedDeviation : d);
			this.setDeviations(newDeviations);
		},
		async addDeviation() {
			let trip = { ...this.trip };
			delete trip.deviations; // Avoid any circular referencing
			let newDeviation = await (await this.returnDeviation(this.newDeviation))({ trip });
			if (newDeviation && newDeviation.id) this.setDeviations([...this.deviations, newDeviation]);
		},
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';

.deviation {
	padding: 10px;
	margin-bottom: 5px;
	cursor: pointer;

	border-width: 1px;
	border-style: solid;
	border-color: #555;
	border-radius: 10px;

	&:hover {
		color: get-color($text, 'selected');
		font-weight: 500;
		border-color: get-color($text, 'selected');

		// background: get-color($blue-scale, 'B3A');
		background: linear-gradient(90deg, get-color($blue-scale, 'B1A') 30%, get-color($blue-scale, 'B3A') 100%);

		// border-image: linear-gradient(90deg, #8eeb9c, #9ab7e9) 1;
		// border: 1px solid linear-gradient(90deg, #8eeb9c 0%, #9ab7e9 100%);
		// border-image: linear-gradient(90deg, #8eeb9c 0%, #9ab7e9 100%);
	}
}

.main {
	display: grid;
	grid-template-columns: 1fr;
	row-gap: 10px;
}

.add-button {
	// max-width: 200px;
	justify-self: left;
	// justify-self: center;
}
</style>
